import {shallow} from "zustand/shallow";
import { SettingStore } from "@/store/setting";

export const useSettingContext = () => {
  const context = SettingStore(state => state);

  if (!context) throw new Error('useSettingContext context must be use inside SettingStore');

  return context;
};
